module.exports = __webpack_public_path__ + "img/grafismo-logo-mappa.74eb10a5.png";